import {
  ScannerTableItemV2Model,
  ScannerTableItemValue,
} from '@c/shared/scanner-symbols-list-v2/scanner-symbols-list-v2.model';
import { RelativelyToMarketTimeOptions } from '@mod/admin/earning.model';
import { INextEarningsCell } from '@u/utils/next-earnings-cell.util';

export enum TopLevelTabs {
  ScannerAll = 'scanner-all',
  ScannerConservative = 'scanner-conservative',
  ScannerAggressive = 'scanner-aggressive',
  Watchlist = 'watchlist',
  Watchlist2 = 'watchlist2',
  Portfolio = 'portfolio',
}

export interface ITableDataV2 {
  id: number;
  security_id: number;
  symbol: string;
  company: string;
  flag: string;
  nextEarnings?: INextEarningsCell;
  earning_report_date?: string | null;
  earning_before_after_market?: string | null;
  has_earnings?: number;
  earning_date_confirmed?: number;
  next_earning_report_date?: string | null;
  next_earning_before_after_market?: RelativelyToMarketTimeOptions | null;
  next_earning_date_confirmed?: number | null;
}

export interface IWheelNextEarning extends ScannerTableItemValue<string | null> {
  badgeLabel: string;
  badgeClass: string;
}
export interface WheelStrategyScannerTableItemV2Model extends ScannerTableItemV2Model {
  nextEarnings: IWheelNextEarning;
}
